import Vue from "vue";
import axios, { AxiosResponse } from "axios";
import VueAxios from "vue-axios";
import { vuexStore } from "@/store";
import { Message } from "@/models/api/Message";
import { messageTypesToName } from "@/static/messageTypes";
import qs from "qs";
import { waitAsync } from "@/utils/wait";
import { parseInt } from "lodash";

if (process.env.VUE_APP_USE_MOCKS?.toLowerCase() === "true") {
  // eslint-disable-next-line
  const mockFactory = require("../../tests/mocks/mock").default;
  mockFactory(axios);
} else {
  axios.defaults.baseURL = process.env.VUE_APP_API_ADDRESS;
}

export const routeParamsFiller = (object: unknown, url: string): string => {
  if (typeof object === "object" && object !== null) {
    Object.entries(object).forEach(([key, value]) => {
      if (typeof value === "string" || typeof value === "number")
        if (url?.includes("${" + key + "}")) {
          url = url?.replace("${" + key + "}", typeof value === "string" ? value : value.toString());
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          delete object[key];
        }
    });
  }
  return url;
};

axios.interceptors.request.use(
  (config) => {
    vuexStore.commit.RAISE_PENDING_CALLS();
    if (typeof config.params === "object") {
      config.url = routeParamsFiller(config.params, config.url as string);
      // Object.entries(config.params).forEach(([key, value]) => {
      //   if (typeof value === "string" || typeof value === "number")
      //     if (config.url?.includes("${" + key + "}")) {
      //       config.url = config.url?.replace("${" + key + "}", typeof value === "string" ? value : value.toString());
      //       delete config.params[key];
      //     }
      // });
    }
    return config;
  },
  (error) => {
    return error;
  }
);

const processMessageFromResponse = (response: AxiosResponse): AxiosResponse => {
  if (!isMessageResponse(response)) return response;
  for (const message of response.data.messages as Message[]) {
    vuexStore.commit.popup.ADD_ALERT({
      content: message.message,
      title: messageTypesToName(message.type),
      type: message.type,
      referenceNumber: message.referenceNumber,
      resolver: () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
    });
  }
  response.data = response.data.model;
  return response;
};

const isMessageResponse = (response: AxiosResponse): boolean => {
  return typeof response.data.messages !== "undefined" && typeof response.data.model !== undefined;
};

axios.interceptors.response.use(
  async (response) => {
    if (/true/i.test(process.env.VUE_APP_DELAY_FUNCTIONALITY ?? "")) {
      const delay = localStorage.getItem("delay");
      if (delay !== null && typeof parseInt(delay) === "number") {
        await waitAsync(parseInt(delay));
      }
    }
    vuexStore.commit.LOWER_PENDING_CALLS();
    return processMessageFromResponse(response);
  },
  async (error) => {
    vuexStore.commit.LOWER_PENDING_CALLS();
    if (typeof error.response !== "undefined") {
      if (error.response.status === 401) {
        await vuexStore.dispatch.user.logoutCurrentOffice();
      }
      if (error.response.status === 403) {
        await vuexStore.dispatch.user.noPermissions();
      }
      if (
        error.request.responseType === "blob" &&
        error.response.data instanceof Blob &&
        error.response.data.type &&
        error.response.data.type.toLowerCase().indexOf("json") != -1
      ) {
        error.response.data = JSON.parse(await error.response.data.text());
      }
      error.response = processMessageFromResponse(error.response);
      return error.response;
    }
    return error;
  }
);

axios.defaults.paramsSerializer = (params) => qs.stringify(params, { allowDots: true });

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const originalTransformer = axios.defaults.transformRequest[0];
axios.defaults.transformRequest = (data, headers) => {
  if (["string", "number", "boolean"].includes(typeof data)) {
    headers.patch["Content-Type"] = "application/json";
    headers.put["Content-Type"] = "application/json";
    headers.post["Content-Type"] = "application/json";
    return JSON.stringify(data);
  } else {
    return originalTransformer(data, headers);
  }
};

export const setAuthAxios = (token: string): void => {
  axios.defaults.headers["Authorization"] = "Bearer " + token;
};

export const removeAuthAxios = (): void => {
  delete axios.defaults.headers.common["Authorization"];
};

Vue.use(VueAxios, axios);
// const axiosInstance = axios;
export { axios as axiosInstance };
export default axios;
